export default {
  ru: {
    title: "РЕМОНТ СИНХРОННЫХ ЭЛЕКТРОДВИГАТЕЛЕЙ",
    content: "<p class='py-2'>Предлагаем Вам выполнение работ по ремонту синхронных электродвигателей как на нашей производственной базе, как и по месту установки, при больших габаритах и сложности транспортировки, а именно:</p>\n" +
      "\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Ремонт высоковольтных синхронных электродвигателей с явно выраженными полюсами;</li>\n" +
      "<li class='list-disc'>Ремонт синхронных гидрогенераторов;</li>\n" +
      "<li class='list-disc'>Ремонт турбоэлектродвигателей и турбогенераторов;</li>\n" +
      "<li class='list-disc'>Ремонт тяговых синхронных генераторов;</li>" +
      "</ul>\n"
  },
  en: {
    title: "REPAIR OF SYNCHRONOUS ELECTRIC MOTORS",
    content: "<p class='py-2'>We offer you performance of works on repair of synchronous electric motors both on our production base, as well as in the place of installation, with large dimensions and complexity of transportation, namely:</p>\n" +
      "\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Repair of high-voltage synchronous motors with pronounced poles;</li>\n" +
      "<li class='list-disc'>Repair of synchronous hydro generators;</li>\n" +
      "<li class='list-disc'>Repair of turboelectric motors and turbogenerators;</li>\n" +
      "<li class='list-disc'>Repair of traction synchronous generators;</li>" +
      "</ul>\n"
  },
  ua: {
    title: "РЕМОНТ СИНХРОННИХ ЕЛЕКТРОДВИГУНІВ",
    content: "<p class='py-2'>Пропонуємо Вам виконання робіт по ремонту синхронних електродвигунів як на нашій виробничій базі, так і за місцем установки, при великих габаритах і складності транспортування, а саме:</p>\n" +
      "\n" +
      "<ul class='px-8'>" +
      "<li class='list-disc'>Ремонт високовольтних синхронних електродвигунів з явно вираженими полюсами;</li>\n" +
      "<li class='list-disc'>Ремонт синхронних гідрогенераторів;</li>\n" +
      "<li class='list-disc'>Ремонт турбоелектродвигунів і турбогенераторів;</li>\n" +
      "<li class='list-disc'>Ремонт тягових синхронних генераторів;</li>" +
      "</ul>\n"
  },
}

